import { getClientPublicAccess } from './subscriptionProperties.utils';

const getIsClientPublicAccessBlocked = (subscription: Subscription) => {
  return getClientPublicAccess(subscription) === false;
};

export default getIsClientPublicAccessBlocked;
